import Image from '@/components/Image';
import { Link } from '@/i18n/navigation';
import { useTranslations } from 'next-intl';
import { Tab } from './Tabs/Tabs';

export interface ICard {
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    onMouseMove?: (event: React.MouseEvent) => void;
    link: string;
    activeTab?: Tab;
    description: string;
    date?: string;
    title: string;
    label?: string;
    focus?: { color?: string };
    imageSrc?: string;
}

export default function BlogCard({
    onMouseEnter,
    onMouseLeave,
    onMouseMove,
    link,
    activeTab,
    title,
    description,
    date,
    label,
    focus,
    imageSrc,
}: ICard) {
    const t = useTranslations('Insights');
    return (
        <Link
            href={link}
            className="group relative transition duration-300 bg-violet hover:cursor-none flex flex-col"
            onMouseMove={onMouseMove}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div
                className="p-5 lg:p-8 flex flex-col gap-2 2xl:gap-5 h-full"
                style={{ border: focus?.color ? `4px solid ${focus.color}` : 'none' }}
            >
                <span
                    className="text-white/50 font-normal text-md 2xl:text-[25px] leading-none text-nowrap"
                    style={{ color: focus?.color ? focus.color : 'inherit' }}
                >
                    [{activeTab ? activeTab.label : label}]
                </span>
                <h3 className="lg:min-h-24 text-white font-normal text-4xl 2xl:text-[42px] 2xl:leading-[42px] line-clamp-4 lg:line-clamp-3 uppercase leading-none">
                    {title}
                </h3>
                <div className="mt-auto">
                    <p className="line-clamp-3 text-gray-200 font-helvetica-neue text-base 2xl:text-[22px] tracking-wide font-light leading-tight">
                        {description}
                    </p>
                    <p className="mt-2 2xl:mt-6 h-6 text-black tracking-wide text-lg 2xl:text-xl leading-6 font-helvetica-neue font-light">
                        {date}
                    </p>
                </div>
            </div>
            <div className="group relative">
                <Image
                    src={imageSrc || '/img/placeholder.png'}
                    alt={title}
                    width={400}
                    height={400}
                    className="w-full object-cover mt-auto h-52"
                    forceSrc={imageSrc ? true : false}
                />
                <div className="absolute inset-0 bg-black/50 group-hover:bg-black/0 transition-all duration-300" />
            </div>
        </Link>
    );
}
